// NATIVE


// INSTALLED
import Avatar from '@mui/material/Avatar';


// CUSTOM


export const LogoPlatform = () => {


  // REDUX

  return (
    <Avatar alt="Remy Sharp" src="https://mui.com/static/images/avatar/1.jpg" />
  )
}

